import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { EuiEditorModule } from '@eui/components/externals/eui-editor';
import { EuiAllModule } from '@eui/components';
import { EclAllModule } from '@eui/ecl';
import { TimelineComponent } from '@shared/components/timeline/timeline.component';
import { TimelineItemComponent } from '@shared/components/timeline/timeline-item.component';
import { ForbiddenComponent } from '@shared/components/forbidden/forbidden.component';
import {
    LoginOrCreateAccountDialogComponent
} from '@shared/components/dialogs/login-or-create-account-dialog/login-or-create-account-dialog.component';
import {
    MemberStateDialogComponent
} from '@shared/components/dialogs/member-state-dialog/member-state-dialog.component';
import { BasicDialogComponent } from '@shared/components/dialogs/basic-dialog.component';
import { FormatBytesPipe } from '@shared/pipes/format-bytes.pipe';
import {
    TermsAndConditionsDialogComponent
} from '@shared/components/dialogs/terms-and-conditions-dialog/terms-and-conditions-dialog.component';
import {
    MemberStateOptionChoiceDialogComponent
} from '@shared/components/dialogs/member-state-option-choice-dialog/member-state-option-choice-dialog.component';
import {
    SubnationalTerritorialEntityDialogComponent
} from '@shared/components/dialogs/subnational-territorial-entity-dialog/subnational-territorial-entity-dialog.component';
import { AuthGuard } from '@shared/guards/auth.guard';
import { CanDeactivateGuard } from '@shared/guards/can-deactivate.guard';
import { QuillEditorComponent } from '@shared/components/quill-editor/quill-editor.component';
import { SafeDownloadPipe } from '@shared/pipes/safe-download.pipe';
import { PdfViewerComponent } from '@shared/components/pdf-viewer/pdf-viewer.component';
import { DisclosedDocumentComponent } from '@shared/components/disclosed-document/disclosed-document.component';

const MODULES = [
    RouterModule,
    EclAllModule,
    EuiAllModule,
    TranslateModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    EuiEditorModule
];

@NgModule({
    imports: [...MODULES
    ],
    declarations: [
        SafeDownloadPipe,
        FormatBytesPipe,
        PdfViewerComponent,
        DisclosedDocumentComponent,
        TimelineComponent,
        TimelineItemComponent,
        QuillEditorComponent,
        ForbiddenComponent,
        BasicDialogComponent,
        LoginOrCreateAccountDialogComponent,
        TermsAndConditionsDialogComponent,
        MemberStateDialogComponent,
        MemberStateOptionChoiceDialogComponent,
        SubnationalTerritorialEntityDialogComponent
    ],
    exports: [...MODULES,
        SafeDownloadPipe,
        FormatBytesPipe,
        PdfViewerComponent,
        DisclosedDocumentComponent,
        TimelineComponent,
        TimelineItemComponent,
        QuillEditorComponent,
        ForbiddenComponent,
        LoginOrCreateAccountDialogComponent,
        TermsAndConditionsDialogComponent,
        MemberStateDialogComponent,
        MemberStateOptionChoiceDialogComponent,
        SubnationalTerritorialEntityDialogComponent
    ],
    providers: [
        AuthGuard,
        CanDeactivateGuard
    ]
})
export class SharedModule {
}
